import { FC } from "react";
import { DetailBooking } from "~/components/admin/bookings";

type Props = {};

export const ScreenDetailBooking: FC<Props> = () => {
  return <DetailBooking />;
};
